<div class="skeleton-container">
  <div class="breadcrumb-row skeleton-row">
    <div class="skeleton-item"></div>
  </div>

  <div class="main-content-row">
    <div class="main-content-col left-col">
      <div class="skeleton-row">
        <div class="skeleton-item w-90 medium-item"></div>
        <div class="skeleton-item w-70"></div>
      </div>

      <div class="skeleton-row">
        <div class="skeleton-item w-50"></div>
        <div class="skeleton-item w-70"></div>
      </div>

      <div class="skeleton-row">
        <div class="skeleton-item w-50"></div>
        <div class="skeleton-item w-70"></div>
      </div>

      <div class="skeleton-row">
        <div class="skeleton-item w-50"></div>
        <div class="skeleton-item w-70"></div>
        <div class="skeleton-item w-70"></div>
      </div>

      <div class="skeleton-row">
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
      </div>

      <div class="skeleton-row">
        <div class="skeleton-item w-50"></div>
        <div class="skeleton-item w-70"></div>
      </div>

      <div class="line"></div>

      <div class="skeleton-row last">
        <div class="skeleton-item w-50"></div>
        <div class="skeleton-row row last align-center">
          <div class="skeleton-item circle"></div>
          <div class="skeleton-row last">
            <div class="skeleton-item w-90"></div>
            <div class="skeleton-item w-50"></div>
          </div>
        </div>
      </div>

    </div>

    <div class="main-content-col center-col">
      <div class="center-col-section first-section">
        <div class="skeleton-row line-1">
          <div class="skeleton-item medium-item"></div>
        </div>

        <div class="skeleton-row line-2">
          <div class="skeleton-item w-66"></div>
        </div>

        <div class="skeleton-row row line-3">
          <div class="skeleton-row last">
            <div class="skeleton-item w-60"></div>
            <div class="skeleton-item"></div>
          </div>
          <div class="skeleton-row last">
            <div class="skeleton-item w-60"></div>
            <div class="skeleton-item"></div>
          </div>
          <div class="skeleton-row last">
            <div class="skeleton-item w-60"></div>
            <div class="skeleton-item"></div>
          </div>
        </div>
      </div>

      <div class="center-col-section second-section">
        <div class="skeleton-row row last">
          <div class="skeleton-row last">
            <div class="skeleton-row">
              <div class="skeleton-item medium-item w-40"></div>
            </div>
            <div class="skeleton-row last">
              <div class="skeleton-item big-2-item"></div>
            </div>
          </div>
          <div class="skeleton-row last">
            <div class="skeleton-row">
              <div class="skeleton-item medium-item w-40"></div>
            </div>
            <div class="skeleton-row last">
              <div class="skeleton-item big-2-item"></div>
            </div>
          </div>
        </div>

      </div>

      <div class="center-col-section third-section">
        <div class="skeleton-row">
          <div class="skeleton-item medium-item w-20"></div>
        </div>
        <div class="skeleton-row">
          <div class="skeleton-item big-3-item"></div>
        </div>
        <div class="space"></div>
        <div class="skeleton-row">
          <div class="skeleton-item medium-item w-20"></div>
        </div>
        <div class="skeleton-row last">
          <div class="skeleton-item big-3-item"></div>
        </div>
      </div>
    </div>

    <div class="main-content-col right-col">
      <div class="skeleton-row row">
        <div class="skeleton-row last">
          <div class="skeleton-item w-45"></div>
          <div class="skeleton-item"></div>
        </div>
        <div class="skeleton-row last">
          <div class="skeleton-item w-45"></div>
          <div class="skeleton-item"></div>
        </div>
      </div>

      <div class="skeleton-row">
        <div class="skeleton-item big-item"></div>
      </div>

      <div class="skeleton-row last">
        <div class="skeleton-item big-item"></div>
      </div>
    </div>
  </div>
</div>
